import { AxiosResponse } from 'axios';
import download from 'downloadjs';

export function getFileNameFromContentDisposition(response: AxiosResponse<Blob | undefined>) {
    // Taken from https://stackoverflow.com/questions/40939380/how-to-get-file-name-from-content-disposition
    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches?.[1]) {
            return matches[1].replace(/['"]/g, '');
        }
    }
}

export const downloadFileFromResponse = (response: AxiosResponse<Blob | undefined>) => {
    const { data: file } = response;
    if (file) {
        const fileName = getFileNameFromContentDisposition(response) || 'download';
        download(file, fileName, file.type);
    }
};
